import Slider from './Slider'

export default {
  Slider
}



// WEBPACK FOOTER //
// ./src/components/sliders/index.js